import { render } from "./CostiContrattiSottoprogetto.vue?vue&type=template&id=af693152&scoped=true&ts=true"
import script from "./CostiContrattiSottoprogetto.vue?vue&type=script&lang=ts"
export * from "./CostiContrattiSottoprogetto.vue?vue&type=script&lang=ts"

import "./CostiContrattiSottoprogetto.vue?vue&type=style&index=0&id=af693152&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af693152"]])

export default __exports__